module.exports = __webpack_public_path__ + "img/kefu.110b18bf.png";